import { setErrorMessage } from "../utils/ToastMessageUtils";
import { http } from "../utils/http-common";
import { Workflow } from "../interfaces/WorkflowInterface";

export function getWorkflows() {
  return http
    .get("/workflows")
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function getWorkflowsWithStages() {
  return http
    .get("/workflows?with=workflowStages,workflowStages.actions")
    .then((res) => res.data.data)
    .catch((err) => console.log(err));
}

export function getSingleWorkflow(id: number) {
  return http
    .get(`/workflows/${id}`)
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      console.log(err);
      setErrorMessage("There was an error obtaining workflow information. Please try again later.");
    });
}

export async function workflowHasOrderItems(id: number) {
  const res = await http.get(`/orderItems/countItemsInWorkflow?workflowId=${id}`);
  return res.data.count > 0;
}
export function deleteWorkflow(workflowId: number) {
  return http.delete(`/workflows/${workflowId}`);
}
export function createWorkflow(workflow: Workflow) {
  return http.post(`/workflows`, workflow).then((res) => {
    return res.data.data;
  });
}

export function editWorkflow(workflow: Workflow, workflowId: number) {
  const { id, createdAt, updatedAt, companyId, ...workflowToEdit } = workflow;
  return http.put(`/workflows/${workflowId}`, workflowToEdit).then((res) => {
    return res.data.data;
  });
}
